<template>
  <div class="app-container">
    <el-card class="box-card coutomer-time" v-if="configObj">
      客服工作时间：{{configObj.content === '10'?'每天':'工作日'}} {{configObj.content1}} <i class="el-icon-edit" @click="handleService" v-hasPermi="['customer:personnel:time']"></i>
    </el-card>
    <el-card class="box-card mt10">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="姓名：">
            <el-input v-model="query.realName" placeholder="请输入客服姓名" clearable size="small" />
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.mobile" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="工作状态：">
            <!-- workStatus  在线 10 离线 20 离开 30-->
            <el-select v-model="query.workStatus" placeholder="请选择" clearable size="small">
              <el-option label="上线" :value="10"></el-option>
              <el-option label="离线" :value="20"></el-option>
              <el-option label="离开" :value="30"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会客数：">
            <el-input v-model="query.conversationCountStart" style="width: 200px" placeholder="开始" clearable size="small" /> -
            <el-input v-model="query.conversationCountEnd" style="width: 200px" placeholder="结束" clearable size="small" />
          </el-form-item>
          <el-form-item label="时间区域：">
            <el-select v-model="timeType" placeholder="请选择" clearable size="small">
              <el-option label="上次在线时间" :value="1"></el-option>
              <el-option label="入职时间" :value="2"></el-option>
              <el-option label="修改时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane name="10"><span slot="label">在职({{statusCount.status10 || 0}})</span></el-tab-pane>
          <el-tab-pane name="30"><span slot="label">离职({{statusCount.status30 || 0}})</span></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleCreate" plain>导出</el-button> -->
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,1)" v-hasPermi="['customer:personnel:status']">设为上线</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,2)" v-hasPermi="['customer:personnel:status']">设为离线</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,3)" v-hasPermi="['customer:personnel:status']">设为离开</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,4)" v-hasPermi="['customer:personnel:state']">离职</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,5)" v-hasPermi="['customer:personnel:state']">入职</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['customer:personnel:add']">新增客服</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="编号" prop="id" align="center" fixed key="1" />
        <el-table-column label="姓名" prop="realName" align="center" fixed key="2">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row,2)">{{row.realName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="头像" prop="name" align="center" v-if="activeName === '10'" key="3">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" :src="row.headImg" :preview-src-list="[row.headImg]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="性别" prop="sex" align="center" key="4">
          <template slot-scope="{row}">
            {{row.sex === 1?'男':(row.sex === 2?'女':'')}}
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile" align="center" key="5" />
        <el-table-column label="会客数" prop="conversationCount" align="center" key="6" />
        <el-table-column label="工作状态" prop="workStatus" align="center" v-if="activeName === '10'" key="7">
          <template slot-scope="{row}">
            <el-dropdown @command="handleCommand1">
              <el-button type="text">{{row.workStatus === 10?'在线':(row.workStatus === 20?'离线':'离开')}}<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown" v-hasPermi="['customer:personnel:status']">
                <!-- workStatus  在线 10 离线 20 离开 30-->
                <el-dropdown-item :command="beforeHandleCommand1(row,1)" v-if="row.workStatus != 10">上线</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand1(row,2)" v-if="row.workStatus != 20">离线</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand1(row,3)" v-if="row.workStatus != 30">离开</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
        <el-table-column label="好评" prop="positiveCommentCount" align="center" key="8" />
        <el-table-column label="差评" prop="negativeCommentCount" align="center" key="9" />
        <el-table-column label="风控次数" prop="riskControlCount" align="center" width="160px" key="10">
          <template slot-scope="{row}">
            <el-input-number v-if="activeName === '10'" :class="{'ared': row.riskControlCount > maxRiskCount && maxRiskCount != -1}" v-model="row.riskControlCount" :step="1" step-strictly size="mini" @change="handleChange(row)" :min="0"></el-input-number>
            <span v-else>{{row.riskControlCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="上次在线时间" prop="lastOnlineTime" sortable="custom" align="center" width="200" v-if="activeName === '10'" key="11" />
        <el-table-column label="入职时间" prop="entryTime" sortable="custom" align="center" width="200" v-if="activeName === '10'" key="12" />
        <el-table-column label="修改时间" prop="operatedTime" sortable="custom" align="center" width="200" v-if="activeName === '10'" key="13" />
        <el-table-column label="离职时间" prop="resignTime" sortable="custom" align="center" width="200" v-if="activeName === '30'" key="14" />
        <el-table-column label="操作人" prop="operatedName" align="center" v-if="activeName === '30'" key="15" />
        <el-table-column label="操作" align="center" width="230" fixed="right" key="16">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)" v-hasPermi="['customer:personnel:edit']">编辑</el-button>
            <el-button type="text" @click="handleStatus(row)" v-hasPermi="['customer:personnel:state']">{{row.status === 10?'离职':'入职'}}</el-button>
            <el-button type="text" @click="handleLog(row)">日志记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <personnel-add ref="personnelAdd" @created="doQueryList({})" />
    <service-time-vue ref="serviceTimeVue" @created="getServiceTime()" />
  </div>
</template>

<script>
import personnelAdd from './add.vue'
import serviceTimeVue from './serviceTime.vue'
import custServiceStaffApi from '@/api/customer/custServiceStaff'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'
export default {
  //sourceType  1新人福利 2课程管理
  props: ['sourceType'],
  components: {
    Pagination,
    personnelAdd,
    serviceTimeVue
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        status: undefined,
      },
      selectItems: [],
      timeType: null,
      dateTime: [],
      activeName: '10',
      configObj: null,
      statusCount: {},
      maxRiskCount: -1
    }
  },
  created() {
    this.getServiceTime();
    this.doQueryList({ pageNo: 1 })

  },
  methods: {
    getServiceTime() {
      sysDataconstantApi.fetchBatchCode({ code: 'custServiceWorkTime,riskControlMaxCount' }).then(({ data }) => {
        let list = data.list;
        this.configObj = list.find(item => item.code === 'custServiceWorkTime')
        let findObj = list.find(item => item.code === 'riskControlMaxCount')
        if (findObj) this.maxRiskCount = +findObj.content
      })
    },
    getStatusCount() {
      custServiceStaffApi.statusCount().then(({ data }) => {
        this.statusCount = data
      })
    },
    handleFilter() {
      this.query = {}
      this.timeType = ''
      this.dateTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    resetTime() {
      this.query.lastOnlineTimeStart = undefined
      this.query.lastOnlineTimeEnd = undefined
      this.query.entryTimeStart = undefined
      this.query.entryTimeEnd = undefined
      this.query.operatedTimeStart = undefined
      this.query.operatedTimeEnd = undefined
    },
    calcQuery() {
      this.resetTime()
      if (this.dataTime && this.dataTime.length > 0) {
        if (this.timeFilter === 1) {
          this.query.lastOnlineTimeStart = this.dateTime[0]
          this.query.lastOnlineTimeEnd = this.dateTime[0]
        } else if (this.timeFilter === 2) {
          this.query.entryTimeStart = this.dateTime[0]
          this.query.entryTimeEnd = this.dateTime[0]
        } else if (this.timeFilter === 3) {
          this.query.operatedTimeStart = this.dateTime[0]
          this.query.operatedTimeEnd = this.dateTime[0]
        }
      }
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.calcQuery()
      this.query.status = +this.activeName
      this.listLoading = true
      return custServiceStaffApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
          this.getStatusCount()
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => custServiceStaffApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => custServiceStaffApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.batchSetWorkStatus(ids, 10)
      } else if (command.command === 2) {
        this.batchSetWorkStatus(ids, 20)
      } else if (command.command === 3) {
        this.batchSetWorkStatus(ids, 30)
      } else if (command.command === 4) {
        this.$common.confirm(`是否确认将${ids.length}个客服设为离职`).then(() => {
          this.batchSetStatus(ids, 30)
        })
      } else if (command.command === 5) {
        this.$common.confirm(`是否确认将${ids.length}个客服设为入职`).then(() => {
          this.batchSetStatus(ids, 10)
        })
      }
    },
    beforeHandleCommand1(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand1(command) {
      let id = [command.row.id]
      if (command.command === 1) {
        this.batchSetWorkStatus(id, 10)
      } else if (command.command === 2) {
        this.batchSetWorkStatus(id, 20)
      } else if (command.command === 3) {
        this.batchSetWorkStatus(id, 30)
      }
    },
    batchSetWorkStatus(ids, status) {
      custServiceStaffApi.setWorkStatusBatch({ ids: ids, workStatus: status }).then(() => {
        this.$common.showMsg('success', '操作成功')
        this.doQueryList({})
      })
    },
    batchSetStatus(ids, status) {
      custServiceStaffApi.setStatusBatch({ ids: ids, status }).then(() => {
        this.$common.showMsg('success', '操作成功')
        this.doQueryList({})
      })
    },
    handleStatus(row) {
      let txt = `是否确认将该客服设为${row.status === 10 ? '离职' : '入职'}`
      let status = row.status === 10 ? 30 : 10
      this.$common.confirm(txt).then(() => {
        this.batchSetStatus([row.id], status)
      })
    },
    handleChange(row) {
      // 防抖处理，500毫秒内不再输入则执行接口调用
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.fetchData(row);
      }, 1000);
    },
    fetchData(row) {
      // 调用接口的方法
      custServiceStaffApi.setRiskControl({ id: row.id, riskControlCount: row.riskControlCount }).then(() => {

      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.personnelAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.personnelAdd.handleUpdate(row)
    },
    handleService() {
      this.$refs.serviceTimeVue.handleUpdate(this.configObj)

    },
    handleLog(row) {
      this.$router.push("/log/log?type=80&id=" + row.id);
    }
  }
}
</script>
<style lang="scss" scoped>
.coutomer-time {
  i {
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
    padding-left: 5px;
  }
}
::v-deep .el-input-number--mini {
  width: 100px;
}
::v-deep .ared .el-input--mini .el-input__inner{
  color: red !important
}
</style>